import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames, createQA } from "@multiweb/reactUtils";
import { ExtendedPropertiesType } from "@multiweb/types/multiweb";
import { QAProps } from "@multiweb/types/react";
import { Role } from "@multiweb/uiShared/Role";
import { TemplateLayoutVariant } from "./enums";

export type TemplateLayoutItemProps = QAProps & {
    /**
     * Obsah k zasazení itemu.
     */
    content: ReactNode;
    /**
     * Výška položky. Běžně není tuto proměnnou potřeba používat, jelikož se výška počítá automaticky,
     * avšak někdy může být potřeba z nějakého důvodu určit výšku položky manuálně.
     */
    height?: string | number;
    /** Upravuje výchozí chování vzhledu. */
    variant?: TemplateLayoutVariant;
    /**
     * Role pro přístupnost.
     */
    role?: Role;
    /**
     * Dodatečné vlastnosti položky.
     */
    extendedProperties?: ExtendedPropertiesType;
};

const classNames = bemClassNames("template-layout-item");

/**
 * Komponenta sloužící k vykreslení atributu.
 */
export const TemplateLayoutItem: FunctionComponent<TemplateLayoutItemProps> = ({
    content,
    height,
    qa,
    variant = TemplateLayoutVariant.default,
    role = Role.cell,
    extendedProperties,
}) => (
    <div
        className={classNames({ variant })}
        style={{ height }}
        {...createQA(qa)}
        {...extendedProperties}
        {...{ role }}
    >
        {content}
    </div>
);
